(function() {
  var TARGET_SELECTOR = '[data-card-banner-auto-fit]';
  var resizeRafId = 0;
  var MIN_SCALE = 0.1;
  var FIT_HEADROOM = 0.94;
  var FIT_WIDTH_HEADROOM_PX = 10;

  function setScale(target, scale) {
    target.style.setProperty('--card-banner-auto-fit-scale', scale.toFixed(3));
  }

  function fitsInsideOverlay(target, overlayEl) {
    if (!target || !overlayEl) return false;
    var targetRect = target.getBoundingClientRect();
    var overlayRect = overlayEl.getBoundingClientRect();
    var epsilon = 0.5;
    return targetRect.width <= (overlayRect.width + epsilon) && targetRect.height <= (overlayRect.height + epsilon);
  }

  function hasContentOverflow(el) {
    if (!el) return true;
    var epsilon = 0.5;
    return (el.scrollWidth - el.clientWidth) > epsilon || (el.scrollHeight - el.clientHeight) > epsilon;
  }

  function tightenFitTextWidth(target, mediaEl, overlayEl) {
    if (!target.classList.contains('is-fit-text')) return;

    var overlayStyles = window.getComputedStyle(overlayEl);
    var overlayPaddingLeft = parseFloat(overlayStyles.paddingLeft || '0') || 0;
    var overlayPaddingRight = parseFloat(overlayStyles.paddingRight || '0') || 0;
    var overlayContentWidth = overlayEl.clientWidth - overlayPaddingLeft - overlayPaddingRight;
    var availableWidth = Math.min(mediaEl.clientWidth, overlayContentWidth);
    if (!Number.isFinite(availableWidth) || availableWidth <= 0) return;

    var maxWidth = Math.max(1, Math.floor(availableWidth - 1));
    target.style.maxWidth = maxWidth + 'px';
    target.style.maxInlineSize = maxWidth + 'px';

    var low = 24;
    var high = maxWidth;
    target.style.width = high + 'px';
    target.style.inlineSize = high + 'px';

    for (var i = 0; i < 16; i += 1) {
      var mid = Math.floor((low + high) / 2);
      target.style.width = mid + 'px';
      target.style.inlineSize = mid + 'px';

      if (!hasContentOverflow(target) && fitsInsideOverlay(target, mediaEl) && fitsInsideOverlay(target, overlayEl)) {
        high = mid;
      } else {
        low = mid + 1;
      }
    }

    var finalWidth = Math.min(maxWidth, high + FIT_WIDTH_HEADROOM_PX);
    target.style.width = finalWidth + 'px';
    target.style.inlineSize = finalWidth + 'px';
  }

  function canFitAtCurrentScale(target, mediaEl, overlayEl) {
    tightenFitTextWidth(target, mediaEl, overlayEl);
    return fitsInsideOverlay(target, mediaEl) && fitsInsideOverlay(target, overlayEl) && !hasContentOverflow(target);
  }

  function fitTarget(target) {
    if (!target || !target.isConnected) return;
    var mediaEl = target.closest('.card-media');
    var overlayEl = target.closest('.card-media-overlay');
    if (!mediaEl || !overlayEl) return;

    var maxScale = parseFloat(target.dataset.cardBannerAutoFitMax || '1.8');
    if (!Number.isFinite(maxScale) || maxScale <= 0) {
      maxScale = 1.8;
    }

    var minScale = MIN_SCALE;
    setScale(target, minScale);
    // Must always remain inside both the visible image area and the overlay area.
    if (!canFitAtCurrentScale(target, mediaEl, overlayEl)) {
      return;
    }

    var low = minScale;
    var high = maxScale;

    if (fitsInsideOverlay(target, overlayEl)) {
      setScale(target, high);
      if (canFitAtCurrentScale(target, mediaEl, overlayEl)) {
        setScale(target, Math.max(minScale, high * FIT_HEADROOM));
        canFitAtCurrentScale(target, mediaEl, overlayEl);
        return;
      }
    }

    for (var i = 0; i < 20; i += 1) {
      var mid = (low + high) / 2;
      setScale(target, mid);
      if (canFitAtCurrentScale(target, mediaEl, overlayEl)) {
        low = mid;
      } else {
        high = mid;
      }
    }

    setScale(target, Math.max(minScale, low * FIT_HEADROOM));
    canFitAtCurrentScale(target, mediaEl, overlayEl);
  }

  function fitAll(context) {
    var scope = context || document;
    scope.querySelectorAll(TARGET_SELECTOR).forEach(fitTarget);
  }

  function scheduleFitAll() {
    if (resizeRafId) return;
    resizeRafId = window.requestAnimationFrame(function() {
      resizeRafId = 0;
      fitAll(document);
    });
  }

  document.addEventListener('shopify:section:load', function() {
    fitAll(document);
  });
  window.addEventListener('resize', scheduleFitAll);
  window.addEventListener('load', scheduleFitAll);
  if (document.fonts && typeof document.fonts.ready === 'object') {
    document.fonts.ready.then(scheduleFitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fitAll(document);
    });
  } else {
    fitAll(document);
  }
})();
